import { useRef, lazy, Suspense, useEffect } from 'react';

import { useCheckList } from '@/hooks/useCheckList';
import { useIsHideCheckList, useShowCheckListActions } from '@/store/showCheckListStore';

import { Wrapper } from './CheckListStyles';
import Doughnut from './components/Doughnut';

const CheckList = lazy(() => import('./CheckList'));

const ChecklistWrapper = () => {
  const { progress } = useCheckList();
  const { toggleShowCheckList, setIsHideCheckList } = useShowCheckListActions();
  const isHideCheckList = useIsHideCheckList();
  const doughnutRef = useRef<HTMLDivElement | null>(null);

  const handleDoughnutClick = () => {
    toggleShowCheckList();
  };

  const handleClose = () => {
    setIsHideCheckList(true);
  };

  useEffect(() => () => setIsHideCheckList(true), []); // hides the checklist when the component unmounts

  return (
    <Wrapper>
      <Doughnut ref={doughnutRef} percent={progress} onClick={handleDoughnutClick} />
      <Suspense fallback={null}>
        <CheckList anchorEl={doughnutRef.current} open={!isHideCheckList} onClose={handleClose} />
      </Suspense>
    </Wrapper>
  );
};

export default ChecklistWrapper;
